import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default forwardRef(({ children, className: customcls, visible, transition, as: Heading = "div" }, ref) => {
    const shown = !transition || visible;
    return <div className={cn(styles.root, customcls)} ref={ref}>
        <div aria-hidden="true" className={cn(styles.sectionTitle, styles.block)}>{children}</div>
        {shown && (
            <Heading className={cn(styles.sectionTitle, transition && 'section-motion')}>{children}</Heading>
        )}
    </div>
});
